export default __webpack_public_path__ + "static/media/13_Liska_obecna_PELZ_upr.416f44bb.mp3";